import {ThreeBarsIcon} from '@primer/octicons-react'
import {IconButton} from '@primer/react'

import {useLayoutContext} from './layout-context'
import styles from './SidebarToggle.module.css'
import {clsx} from 'clsx'

export function SidebarToggle() {
  const layoutContext = useLayoutContext()
  const {toggleSidebar} = layoutContext

  return (
    <div className={clsx(styles.sidebarToggleButton, layoutContext.slimLineTopTabs && styles.slimLineTopTabs)}>
      <IconButton icon={ThreeBarsIcon} onClick={toggleSidebar} aria-label="Toggle sidebar" />
    </div>
  )
}
